import { render, staticRenderFns } from "./LogoArea.vue?vue&type=template&id=5ae9dbe2&scoped=true&"
var script = {}
import style0 from "./LogoArea.vue?vue&type=style&index=0&id=5ae9dbe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae9dbe2",
  null
  
)

export default component.exports